import { render, staticRenderFns } from "./WideImage.vue?vue&type=template&id=7bb19c43&scoped=true&"
import script from "./WideImage.vue?vue&type=script&lang=js&"
export * from "./WideImage.vue?vue&type=script&lang=js&"
import style0 from "./WideImage.vue?vue&type=style&index=0&id=7bb19c43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb19c43",
  null
  
)

export default component.exports